import gql from "graphql-tag";

export const EXTEND = gql`
  mutation extend($id: ID!){
    extendExpirationDate(id: $id)
  }
`;
